import _toConsumableArray from "/Users/amagna/WebstormProjects/bulletin-ui-v3/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { Chart, registerables } from '../dist/chart.esm';
Chart.register.apply(Chart, _toConsumableArray(registerables));
export default Chart;